<template>
  <q-modal
    id="jobModal"
    class="sl-modal"
    v-model="jobModalOpen"
    :no-esc-dismiss="true"
    :no-backdrop-dismiss="true"
    :content-css="{width: '1000px', height: '600px'}"
  >
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-toolbar-title>
          <q-icon name="fa fa-clipboard"/>
          Roster Job {{job.ROSTER_JOB_ID}}
        </q-toolbar-title>
        <q-icon @click.native="setJobModalOpen(false)" name="clear"/>
      </q-toolbar>

      <div class="sl-row header-row">
        <div class="sl-col-2">
            <label>Job Number</label>
            #{{ job.ROSTER_JOB_ID }}
        </div>
        <div class="sl-col-3">
          <label>Date Started</label>
          {{ job.DATE_CREATED }}
        </div>
        <div class="sl-col-3">
          <label>Started By</label>
          <div class="label green round">
            <span>{{ startedByInitials }}</span>
          </div>
          {{ startedBy }}
        </div>
        <div class="sl-col-2">
          <label>Job Status</label>
          <div
            style="display:inline-block;border-radius:30px"
            class="label"
            :class="{
              'blue': job.statusText == 'Processing',
              'purple': job.statusText == 'Ready for Review',
              'yellow': job.statusText == 'In Review',
              'green' : job.statusText == 'Completed',
              'red' : job.statusText == 'Error'
            }"
          >{{job.statusText}}</div>
        </div>
        <div class="sl-col-2">
          <label>Approval Status</label>
          <div
            v-if="job.approvalStatus"
            style="display:inline-block;border-radius:30px;text-transform:capitalize"
            class="label"
            :class="{
              'blue': job.approvalStatus == 'SUBMITTED' || job.approvalStatus == 'RESUBMITTED',
              'green': job.approvalStatus == 'APPROVED',
              'red': job.approvalStatus == 'REJECTED',
              'yellow': job.approvalStatus == 'EXPIRED',
              'grey': job.approvalStatus == 'NOT SUBMITTED',
              'purple': job.approvalStatus == 'COMPLETED'
            }"
          >{{job.approvalStatus.toLowerCase()}}</div>
          <span v-else>N/A</span>
        </div>
      </div>
      <div class="q-mx-lg">
        <div class="sl-row" style="font-size: 15px;margin-bottom:0">
          <div class="sl-col-6">
            <div class="section-header">
              <h5 class="inline"><q-icon name="book" color="primary" /> Details</h5>
            </div>
            <div><b>Class ID</b>: {{job.CLASS_ID}}</div>
            <div><b>Document Name</b>: {{job.DOCUMENT ? job.DOCUMENT.DOCUMENT_NAME : 'N/A'}}</div>
            <div><b>Number of Students</b>: {{ draftStudents && draftStudents.length }}</div>
          </div>
          <div class="sl-col-6" v-if="job.ROSTER_JOB_STATUS === 4">
            <div class="section-header">
              <h5 class="inline"><q-icon name="error" color="red" /> Error Notes</h5>
            </div>
            <div class="claudeNotes">
              {{ job.ERROR_NOTES }}
            </div>
          </div>
          <div class="sl-col-6" v-else>
            <div class="section-header">
              <h5 class="inline"><q-icon name="comment" color="primary" /> Notes from AI</h5>
            </div>
            <div class="claudeNotes">
              {{ notes }}
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>

      <q-toolbar slot="footer" class="sl-footer">
        <q-toolbar-title></q-toolbar-title>
        <q-btn
          style="margin-right:3px;"
          color="green" 
          @click="review()"
          label="Review"
          v-if="showReviewBtn"
        />
        <q-btn
          outline
          color="faded"
          @click="setJobModalOpen(false)"
          label="Close"
        />
      </q-toolbar>
    </q-modal-layout>
    <draft-student-modal v-if="draftStudentModalOpen" />
  </q-modal>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import DraftStudentModal from './DraftStudentModal.vue'

export default {
  name: 'JobModal',
  components: {
    DraftStudentModal,
  },
  mounted() {
    this.fetchDraftStudents({ jobId: this.job.ROSTER_JOB_ID })
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState('jobs', {
      jobModalOpen: s => s.jobModalOpen,
      job: s => s.currentJob,
      draftStudents: s => s.draftStudents,
      draftStudentsLoading: s => s.draftStudentsLoading,
      draftStudentModalOpen: s => s.draftStudentModalOpen,
    }),
    startedByInitials() {
      return `${this.job.USER.USER_FIRST_NAME[0].toUpperCase()}${this.job.USER.USER_LAST_NAME[0].toUpperCase()}`
    },
    startedBy() {
      return `${this.job.USER.USER_FIRST_NAME} ${
        this.job.USER.USER_LAST_NAME
      }`;
    },
    claude_response() {
      try {
        return JSON.parse(this.job.CLAUDE_RESPONSE)
      } catch (err) {
        console.log('could not parse claude response: ', this.job.CLAUDE_RESPONSE)
      }
      return {}
    },
    notes() {
      if (this.claude_response) {
        return this.claude_response.notes
      }

      return ""
    },
    showReviewBtn() {
      return [2, 5].includes(this.job.ROSTER_JOB_STATUS)
    }
  },
  methods: {
    ...mapMutations('jobs', [
      'setJobModalOpen',
      'setDraftStudentModalOpen',
    ]),
    ...mapActions('jobs', [
      'fetchDraftStudents',
    ]),
    review() {
      this.setDraftStudentModalOpen(true)
    }
  },
}
</script>

<style lang="stylus">
@import '~variables';

#jobModal {
  .section-header {
    margin-top: 30px;
    margin-bottom: 10px;

    h5 {
      margin-top: 0;
    }

    .label {
      &.small {
        margin: 0 7px 7px 0;
      }
    }
  }

  .modal-content {
    max-height: 100%;
  }
  .sl-table{
    border-radius: 8px 8px 0 8px  
  }
  .sl-footer {
    .q-btn {
      margin-left: 5px;
    }
  }

  .pull-right {
    float: right;
  }

  .header-row {
    background: #eee;
    border-bottom: 1px solid border-color;

    .sl-col-2, .sl-col-3 {
      padding: 30px 15px;
      border-right: 1px solid border-color;
      position: relative;
      font-weight: 600;
      font-size: 15px;
      height: 110px;

      &:last-child {
        border-right: none;
      }

      .q-icon {
        top: 30%;
        font-size: 40px;
        position: absolute;
        right: 20px;
        color: #b9b9b9;
      }

      label {
        font-weight: 400;
        font-size: 10px;
        letter-spacing: 1px;
        text-transform: uppercase;
        display: block;
        margin: 0 0 5px;
      }
    }

    .label {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
    }
  }

  .meta {
    margin: 0 0 60px;

    .pull-left {
      float: left;
    }

    .text-label {
      font-weight: 600;
      font-size: 13px;
      letter-spacing: 1px;
      text-transform: uppercase;
      display: inline-block;
      margin: 0 0 5px;
    }
    .total{
      float: right;
      padding: 13px 29px;
      background: #dadada;
      border-radius: 0 0 7px 7px;
    }
  }

  .order-total {
    color: #000;

    i {
      font-size: 13px;
      color: #bbb;
    }
  }
  .scrollable-textarea {
    max-height: 150px; /* Fixed height */
    overflow-y: auto; /* Add vertical scrollbar when content overflows */
  }
  .claudeNotes {
    background-color: #eee;
    height: auto;
    min-height: 100px;
    border-radius: 5px;
    padding: 1em;
  }
}

</style>
